import React from "react";

type AmexColorProps = React.SVGProps<SVGSVGElement>;

const AmexColor: React.FC<AmexColorProps> = (props) => {
  // Unique per instance so multiple AmexColor renders don't collide on one DOM id.
  const gradientId = React.useId();
  return (
    <svg viewBox="0 0 120 80" role="img" fill="none" {...props}>
      <title>American Express</title>
      <defs>
        <linearGradient x1="5.1%" y1="5.1%" x2="100%" y2="100%" id={gradientId}>
          <stop stopColor="#51AAD6" offset="0%" />
          <stop stopColor="#1D3A90" offset="100%" />
        </linearGradient>
      </defs>
      <rect width="120" height="80" rx="4" fill={`url(#${gradientId})`} />
      <path
        fill="#FFFFFF"
        d="M27.557,28.241 L18,49.971 L29.445,49.971 L30.861,46.506 L34.106,46.506 L35.521,49.971 L48.117,49.971 L48.117,47.328 L49.238,49.971 L55.757,49.971 L56.877,47.269 L56.877,49.971 L83.071,49.971 L86.257,46.594 L89.236,49.971 L102.687,50 L93.1,39.165 L102.687,28.241 L89.442,28.241 L86.345,31.56 L83.454,28.241 L54.96,28.241 L52.512,33.85 L50.005,28.241 L38.589,28.241 L38.589,30.796 L37.321,28.241 L27.557,28.241 Z M29.769,31.325 L35.344,31.325 L41.686,46.065 L41.686,31.325 L47.792,31.325 L52.689,41.896 L57.202,31.325 L63.278,31.325 L63.278,46.917 L59.591,46.917 L59.562,34.702 L54.164,46.917 L50.86,46.917 L45.432,34.702 L45.432,46.917 L37.822,46.917 L36.377,43.423 L28.59,43.423 L27.144,46.917 L23.074,46.917 Z M66.67,31.325 L81.714,31.325 L86.316,36.434 L91.065,31.325 L95.666,31.325 L88.675,39.165 L95.666,46.917 L90.858,46.917 L86.257,41.749 L81.478,46.917 L66.67,46.917 Z M32.483,33.967 L29.917,40.193 L35.049,40.193 Z M70.387,34.555 L70.387,37.403 L78.587,37.403 L78.587,40.574 L70.387,40.574 L70.387,43.687 L79.59,43.687 L83.867,39.106 L79.767,34.555 Z"
      />
    </svg>
  );
};

export default AmexColor;
